import React from 'react';
import styles from './index.module.scss';

export interface PillTagProps {
  children: React.ReactNode;
  bg?: string;
  color?: string;
}

export default function PillTag({ children, bg, color }: PillTagProps) {
  const style = {
    ...(bg ? { background: bg } : null),
    ...(color ? { color } : null),
  };
  return (
    <span className={styles.tag} style={style}>
      {children}
    </span>
  );
}
